import { render, staticRenderFns } from "./VSkeletonPos.vue?vue&type=template&id=22151504"
import script from "./VSkeletonPos.vue?vue&type=script&lang=js"
export * from "./VSkeletonPos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports